import { TAB_KEYS } from '../../constants';
import type { DrawerTab } from '../../types';

import useTranslate from 'app/i18n/useTranslate';

const useTranslation = (): { tabs: DrawerTab[] } => {
    const t = useTranslate('droneDetailsDrawer');

    const tabs = TAB_KEYS.map(key => ({ key, label: t(key) }));

    return { tabs };
};

export default useTranslation;
